import React from "react";
import {GoogleLogin} from "@react-oauth/google";
import {GoogleOAuthProvider} from "@react-oauth/google";
import Width from "../assets/Width";
import {GlobalScreens} from "../utils/globalConstant";
import Colors from "../assets/Color/Colors";
import { View } from "react-native";

const GoogleLoginRT = ({
  googleClientId,
  responseGoogle,
  responseGoogleError,
  isBasicProfile,
  isDesktop,
}) => {
  return (
    <View style={{
      width: '100%',
      paddingHorizontal: 0,
      minWidth: '100%',
      flex: 1,
    }}>
      <GoogleLogin
        type="standard"
        onSuccess={responseGoogle}
        onError={responseGoogleError}
        auto_select={false}
        use_fedcm_for_prompt={false}
        select_account="true"
        shape="rectangular"
        theme="filled_blue"
        size="large"
        width="100%"
        text="continue_with"
        useOneTap={false}
        style={{
          width: '100%',
          minWidth: '100%',
          flex: 1,
          borderRadius: 4,
          backgroundColor: '#2E80EC'
        }}
      />
    </View>
  );
};

export default GoogleLoginRT;
